// extracted by mini-css-extract-plugin
export default {"commission-history":"CommissionHistory_commission-history__fu853"};